<template>
  <div class="rebag">
    <HeaDer></HeaDer>
    <div class="bgcontent">
      <el-card class="box-card">
        <p class="yuetitle" style="margin-left: 80px;margin-bottom: 30px;">找回报名序号</p>
        <div class="chongzhi">
          <el-form :model="formData" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="姓名" prop="userName">
              <el-input placeholder="请输入姓名,中间不能有空格" v-model="formData.userName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="formData.idCard" placeholder="请输入18位身份证号"></el-input>
            </el-form-item>
            <el-form-item label="问题"  prop="forgetQuestion">
              <el-select v-model="formData.forgetQuestion" placeholder="请选择" style="width:100%;" :popper-append-to-body="false">
                <el-option v-for="(item,index) in options" :key="index" :label="item.dictLabel" :value="item.dictLabel">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="答案" prop="forgetAnswer">
              <el-input placeholder="请输入问题答案" v-model="formData.forgetAnswer"></el-input>
            </el-form-item>
            <p class="zhuyia">注：考生需答对密码保护问题，才能进行报名序号找回</p>
            <el-form-item>
              <el-button  @click="cancelsubmit" style="padding:10px 26px;">取消</el-button>
              <el-button type="primary" @click="chongzhimima" style="padding:10px 26px;">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
    <FooTer></FooTer>
  </div>
</template>

<script>
import HeaDer from '../components/common/header.vue'
import FooTer from '../components/common/footer.vue'
import {dictdataconfig, seeuserinfo} from '@/api/api'
export default {
  name: "fortpas",
  components: {
    HeaDer,
    FooTer
  },
  data() {
    const idCardValidity = (rule, code, callback) => {
      var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
      var tip = ""
      var pass = true

      if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误"
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误"
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          // var last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            tip = "校验位错误"
            pass = false
          }
        }
      }
      if (!pass) {
        callback(new Error(tip))
      } else {
        callback()
      }
      // if (!pass) alert(tip)
      // return pass
    }
    return {
      options: [],
      formData:{
        forgetAnswer:'',
        forgetQuestion:'',
        idCard:'',
        userName:'',
        signUpNo:''
      },
      rules: {
        userName: [{ required: true, message:'请输入姓名', trigger: 'blur'}],
        forgetQuestion: [{ required: true, message:'请选择密保问题', trigger: 'blur'}],
        forgetAnswer: [{ required: true, message:'请输入密保答案', trigger: 'blur'}],
        idCard: [{ required: true, message:'请输入身份证号', trigger: 'blur'},{
          validator: idCardValidity,
          trigger: 'blur'
        }]
      }
    };
  },
  created() {
    dictdataconfig({"objType":'question'}).then(res=>{
      this.options=res.data.data;
    })
  },
  methods: {
    cancelsubmit(){
      this.$router.back(-1);
    },
    chongzhimima() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid){
          seeuserinfo(this.formData).then(res=>{
            if(res.data.code==0){
              this.$router.push({
                path: '/sucxuhao',query:res.data.data[0]
              })
            }else{
              this.$message({
                showClose: true,
                message: '信息输入错误，请确认后再试！',
                type: 'error'
              });
            }
          })

        }
      })


    }
  }
}
</script>

<style scoped>

header {
  height: 120px;
  background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
  margin-top: -20px;
}

.bap {
  color: #ffffff;
  float: left;
  line-height: 130px;
  letter-spacing: 2px;
  text-shadow: #333333 0px 0px 5px;
  font-size: 26px;
}

.bacontent {
  width: 1200px;
  margin: 0 auto;
}

.baimg {
  float: right;
  margin-top: 50px;
}

.bgcontent {
  margin-top: 40px;
}

.box-card {
  margin: 0 auto;
  width: 1200px;
  /*width: 1200px;*/
  margin: 0 auto;
  min-height: 620px;
}

.yuetitle {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
  margin-top: 80px;
}

.chongzhi {
  width: 400px;
  margin: 0 auto;
}
.zhuyia {
  color: #DF0000;
  font-size: 14px;
  margin-left: 32px;
  margin-top:-5px;
  margin-bottom:30px;
}
.el-select-dropdown{
  position: absolute !important;
  left: 0 !important;
  top: 30px !important;
}
</style>
